import { Timestamp } from '@angular/fire/firestore';

export const DEFAULT_APP_VERSION = '1.0.0';

const SEMVER_REGEX = /^\d+\.\d+\.\d+$/;

export function isValidVersion(version: string): boolean {
    return SEMVER_REGEX.test(version);
}

export function ensureVersion(version: string | undefined | null): string {
    if (!version || !isValidVersion(version)) {
        return DEFAULT_APP_VERSION;
    }
    return version;
}

export function incrementVersion(currentVersion: string | undefined | null): string {
    const version = ensureVersion(currentVersion);
    const parts = version.split('.');
    const lastIndex = parts.length - 1;
    parts[lastIndex] = (parseInt(parts[lastIndex], 10) + 1).toString();
    return parts.join('.');
}

export function toDate(value: Date | Timestamp | undefined | null): Date | null {
    if (!value) {
        return null;
    }
    if (value instanceof Timestamp) {
        return value.toDate();
    }
    return value;
}
